import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from '../../../theme';

export const StyledWhereSection = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  text-align: center;
`;

export const StyledWhereInfo = styled.div`
  max-width: ${container('md')};
  font-size: ${fontSize('lg')};
  line-height: 1.6;
  margin: auto;
  
  ul,
  ol,
  p {
    margin-top: ${spacing('lg')};
    margin-bottom: 0;
    
    &:first-child {
      margin-top: 0;
    }
  }
`;

export const StyledWhereContent = styled.div`
  grid-template-columns: 1fr minmax(0, 1fr);
  column-gap: ${spacing('xl')};
  margin-top: ${spacing('lg')};
  padding-top: ${spacing('md')};
  position: relative;

  @media (min-width: ${screen('md')}) {
    display: grid;
  }

  &::before {
    content: '';
    display: block;
    height: 1px;
    width: ${spacing('xl4')};
    background-color: ${color('midnight_200')};
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;
